/**
 * Asynchronously loads the component for NurturingCandidatesViewPage
 */

import { lazyLoad } from 'utils/loadable';

export const NurturingCandidatesViewPage = lazyLoad(
  () => import('./index'),
  module => module.NurturingCandidatesViewPage,
);
